
<div class="banner-onboarding row">
  <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
    <div class="titulo-simpli">
      Descubre si tu empresa califica para un financiamiento
    </div>
    <div class="subtitulo-simpli">
      Completa la <span (click)="irOnboarding()">sincronización de tu empresa</span> y recibe una <strong>evaluación inmediata</strong>, 100% digital.
    </div>
  </div>

  <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
    <div class="sync-button">
      <button mat-stroked-button class="primary-button" (click)="irOnboarding()">Sincronizar mi empresa</button>
    </div>
  </div>
</div>


